/**
 * Formatiert große Zahlen mit deutschen Suffixen.
 * Für Ressourcen-Anzeigen im HUD.
 */
const SUFFIXES = ['', 'K', ' Mio', ' Mrd', ' Bio', ' Brd'];

/** Kompakte Anzeige: ab 1 Mio mit Suffix. unit='t' → "500 t", "2.30 Mrd t". */
export function formatNumber(n: number, unit = ''): string {
  if (n < 0) return '-' + formatNumber(-n, unit);
  const u = unit ? ' ' + unit : '';
  if (n < 1_000_000) return String(Math.round(n)) + u;
  const tier = Math.min(Math.floor(Math.log10(n) / 3), SUFFIXES.length - 1);
  const scaled = n / Math.pow(10, tier * 3);
  const str = scaled >= 100 ? Math.round(scaled).toString()
    : scaled >= 10 ? scaled.toFixed(1)
    : scaled.toFixed(2);
  return str + SUFFIXES[tier] + u;
}

/** Volle Zahl mit Tausender-Punkten. unit='t' → "1.234.567 t". Für Tooltips. */
export function formatFull(n: number, unit = ''): string {
  const s = String(Math.round(n));
  const parts: string[] = [];
  for (let i = s.length; i > 0; i -= 3) {
    parts.unshift(s.slice(Math.max(0, i - 3), i));
  }
  return parts.join('.') + (unit ? ' ' + unit : '');
}

/** Span mit formatNumber + Tooltip (formatFull). */
export function fmtSpan(n: number, style: string, unit = ''): string {
  return `<span style="${style}" title="${formatFull(n, unit)}">${formatNumber(n, unit)}</span>`;
}
